import NotificationsV1 from './v1/Notifications';
import { Notifications as NotificationsV2 } from './v2/Notifications';
import { useFeature } from 'src/app/FeatureToggle';

export default function Notifications() {
  const { isLoading, isEnabled } = useFeature('notifications');

  if (!isLoading && isEnabled) {
    return <NotificationsV2 />;
  }

  return <NotificationsV1 />;
}
